// Borrowed largely from https://github.com/barberboy/geojson-polyline, which unfortunately
// throws errors by just including it in the project...
import polyline from '@mapbox/polyline';

export const flip = coords => coords.map(coord => [...coord].reverse());

export const encode = coords => polyline.encode(flip(coords));

const geoJsonToEncodedPolylines = geojson => {
  switch (geojson.type) {
    // Coordinate arrays
    case 'Point': {
      return encode([geojson.coordinates]);
    }
    case 'MultiPoint':
    case 'LineString': {
      return encode(geojson.coordinates);
    }
    // Arrays of coordinates
    case 'MultiLineString':
    case 'Polygon': {
      return geojson.coordinates.map(encode);
    }
    case 'Feature': {
      return geoJsonToEncodedPolylines(geojson.geometry);
    }
    case 'FeatureCollection': {
      return geojson.features.map(geoJsonToEncodedPolylines);
    }
    case 'GeometryCollection': {
      return geojson.geometries.map(geoJsonToEncodedPolylines);
    }
    case 'MultiPolygon': {
      return geojson.coordinates.map(polygons =>
          polygons.map(encode),
      );
    }
    // Return the original object for unsupported types
    default:
      return geojson;
  }
};

export default geoJsonToEncodedPolylines;



// WEBPACK FOOTER //
// ./src/utils/geoJsonToEncodedPolylines.js